// extracted by mini-css-extract-plugin
module.exports = {"background":"helpCenter_background__fTeHH","contactUsDetails":"helpCenter_contactUsDetails__26Cpv","container":"helpCenter_container__3t2a-"};